<template>
  <div>
    <el-row :gutter="0" style="margin-bottom: 20px;">
      <el-col :span="8">
        <el-button type="primary" @click="openEditModel('ADD')">{{$t('menuConfig.menu.addMenu')}}</el-button>
        <el-button type="" @click="refreshMenu">{{$t('menuConfig.menu.refreshMenu')}}</el-button>
      </el-col>
      
    </el-row>
    <el-row>
      <el-col :span="16">
        <!--show-checkbox-->
        <!--default-expand-all-->
        <el-tree
          :data="resultData"
          :props="defaultProps"
          node-key="id"

          :expand-on-click-node="false"
          :render-content="renderContent">
        </el-tree>
      </el-col>
    </el-row>

    <!--编辑摸态框-->
    <el-dialog :title="modelTitle" :visible.sync="editMenuModelVisible">
      <el-form ref="editForm" :model="editForm" :rules="editRules">

        <el-button @click="initListData">列表</el-button>
        <input type="hidden" />
        <!--<el-form-item :label="$t('menuConfig.menu.menuName')" label-width="120" prop="menuName">-->
          <!--<el-input  auto-complete="off" v-model="editForm.menuName"></el-input>-->
        <!--</el-form-item>-->


        <el-form-item v-for="(item,index) in menuNameLangA" :key="index" :label="item" label-width="120" prop="item">
          <el-input  auto-complete="off" v-model="menuNameLangO[item]"></el-input>
        </el-form-item>



        <el-form-item label="url" label-width="120" prop="url">
          <el-input type="text" v-model="editForm.url" ></el-input>
        </el-form-item>

        <el-form-item label="uri" label-width="120" prop="uri">
          <el-input type="text" v-model="editForm.uri"></el-input>
          <label style="color: darkgrey;">完整路径: @/components/xxx.vue</label>
        </el-form-item>

        <el-form-item label="meta" label-width="120" prop="meta">
          <el-input type="text" v-model="editForm.meta" ></el-input>
        </el-form-item>

        <!--<input type="hidden" v-model="editForm.superId"/>-->
        <input type="hidden" v-model="editForm.subId"/>
        <!--<label >superId: {{ editForm.superId }}</label>-->
        <!--<br />-->
        <!--<label >subId: {{ editForm.subId }}</label>-->
        <!--<el-form-item v-if="editForm.superId && editForm.superId!=0" :label="$t('menuConfig.menu.relUrl')" label-width="120" prop="url">-->
          <!--&lt;!&ndash;<el-input type="text" v-model="editForm.url" ></el-input>&ndash;&gt;-->
          <!--<el-select v-model="editForm.url" :placeholder="$t('menuConfig.menu.selectModel')" style="width: 100%;">-->
            <!--<el-option v-for="item in menuPath" :label="item.name" :value="item.path"></el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item :label="$t('menuConfig.menu.orderBy')" label-width="120" prop="menuSortNo">
          <el-input type="number" v-model="editForm.menuSortNo" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editMenuModelVisible = false">{{$t('mao_global.btn.cancel')}}</el-button>
        <el-button type="primary" @click="submitEditForm()">{{$t('mao_global.btn.ok')}}</el-button>
      </div>
    </el-dialog>
    <!--end 编辑摸态框-->

    <!--编辑顺序摸态框-->
    <el-dialog :title="$t('menu.menuEdit')" :visible.sync="editMenuPosition">
      <el-input-number v-model="menuIndex"  :min="0" :max="9999"></el-input-number>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editMenuPosition = false">{{$t('mao_global.btn.cancel')}}</el-button>
        <el-button type="primary" @click="handleChange()">{{$t('mao_global.btn.ok')}}</el-button>
      </div>
    </el-dialog>
    <!--end 编辑顺序摸态框-->
    <!--编辑顺序摸态框-->
    <el-dialog title="" :visible.sync="editMenuNameAndUrl">
      
      <el-form class='gForm'  ref="submitForm" label-position="right" label-width="12.5%" :model="submitForm" rules="" style="width: 90%;">
        <el-form-item :label="$t('app_name')" prop="roleName">
          <el-input v-model="submitForm.name"></el-input>
        </el-form-item>
        <el-form-item label="URL" prop="memo">
          <el-input v-model="submitForm.url"></el-input>
        </el-form-item>
        <el-form-item label="Icon" prop="memo">
          <el-input v-model="submitForm.icon"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editMenuNameAndUrl = false">{{$t('mao_global.btn.cancel')}}</el-button>
        <el-button type="primary" @click="submitMenuEdit()">{{$t('mao_global.btn.ok')}}</el-button>
      </div>
    </el-dialog>
    <!--end 编辑顺序摸态框-->
  </div>
</template>

<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import ElInput from "element-ui/packages/input/src/input";
  export default {
    components: {ElInput},
    data() {
      return {
        submitForm: {
          name: '',
          url: '',
          icon: '',
          menuId: ''
        },
        menuPath: [
          {
            "name": "任务管理-正在推送任务",
            "path": "/mision-list"
          },
          {
            "name": "任务管理-已完成任务",
            "path": "/mision-history"
          },
          {
            "name": "设备管理-我的设备",
            "path": "/terList"
          },
          {
            "name": "设备管理-终端备份",
            "path": "/terBackups"
          },
          {
            "name": "设备管理-OTA锁定",
            "path": "/terOta"
          },
          {
            "name": "设备管理-终端地图",
            "path": "/map"
          },
          {
            "name": "设备管理-日志管理",
            "path": "/log"
          },
          {
            "name": "广告管理-广告列表",
            "path": "/advert-list"
          },
          {
            "name": "广告管理-广告审核",
            "path": "/examine-list"
          },
          {
            "name": "广告管理-视频广告列表",
            "path": "/video-list"
          },
          {
            "name": "广告管理-视频广告审核",
            "path": "/video-verify"
          },
          {
            "name": "应用管理-应用列表",
            "path": "/appList"
          },
          {
            "name": "应用管理-应用市场",
            "path": "/appSlot"
          },
          {
            "name": "应用管理-应用审核",
            "path": "/appView"
          },
          {
            "name": "数据管理-渠道商管理",
            "path": "/channels"
          },
          {
            "name": "数据管理-厂商管理",
            "path": "/firms"
          },
          {
            "name": "数据管理-设备类型管理",
            "path": "/devices"
          },
          {
            "name": "数据管理-广告类型管理",
            "path": "/adtype"
          },
          {
            "name": "数据管理-设备型号管理",
            "path": "/devices-no"
          },
          {
            "name": "数据管理-应用类型管理",
            "path": "/apptype"
          },
          {
            "name": "系统管理-OTA管理",
            "path": "/romList"
          },
          {
            "name": "系统管理-OTA审核",
            "path": "/romReview"
          },
          {
            "name": "系统管理-系统定制",
            "path": "/romOrder"
          },
          {
            "name": "系统管理-开机动画定制",
            "path": "/romAnimate"
          },
          {
            "name": "系统管理-固件管理",
            "path": "/firmwareManage"
          },
          //
          {
            "name": "系统管理-固件审核",
            "path": "/firmwareCheck"
          },
          {
            "name": "系统管理-固件推送",
            "path": "/firmwarePush"
          },
          {
            "name": "系统管理-launcher管理",
            "path": "/launch-list"
          },
          {
            "name": "系统管理-launcher审核",
            "path": "/launch-check-list"
          },
          //
          {
            "name": "配置管理-角色管理",
            "path": "/roleManager"
          },
          {
            "name": "配置管理-系统配置",
            "path": "/sysSetting"
          },
          {
            "name": "配置管理-LOGO设置",
            "path": "/logoSetting"
          },
          {
            "name": "菜单管理-菜单列表",
            "path": "/menuList"
          },
          {
            "name": "风控管理-围栏设置",
            "path": "/accInfo"
          },
          {
            "name": "风控管理-预警信息",
            "path": "/warn"
          },
          {
            "name": "账号管理-账号信息",
            "path": "/accInfo"
          },
          {
            "name": "账号管理-子账号管理",
            "path": "/accMess"
          },
          {
            "name": "安全管理-我的证书",
            "path": "/certificate"
          },
          {
            "name": "安全管理-证书管理",
            "path": "/certificate"
          },
          {
            "name": "安全管理-远程授权",
            "path": "/remote"
          }
        ],
        // 是否显示添加菜单摸态框
        editMenuModelVisible: false,
        editSortModalVisible: false,
        // 注意: 该字段值为(添加菜单/编辑菜单), 需要更改标题,请全局查询替换; 有部分操作是根据 该字段值来作判断
        modelTitle: this.$t('menuConfig.menu.addMenu2'),
        menuNameLangA: [],
        menuNameLangO: {},
        tempData: '',
        menuIndex: '',
        editMenuPosition: false,
        editMenuNameAndUrl: false,
        tipPath: '',
        editForm: {
          subId: '',
          menuId: '',
          menuName: '',
          superId: '0',
          url: '',
          uri: '',
          menuSortNo: '100',
          menuIcon: '',
          meta: '',
          token: localStorage.getItem("user") | null
        },
        editRules: {
          menuName:[
            { required: true, message: this.$t('menuConfig.menu.notBlankName'), trigger:'blur'}
          ]
        },
//        baseId: 1000,
        // 菜单列表
        resultData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        token: localStorage.getItem("user") | null,
      }
    },
    methods: {
      submitMenuEdit () {
        // console.log(this.submitForm)
        this.$editConfigMenu(this.submitForm, (res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
            this.fetchData()
            this.editMenuNameAndUrl = false
            
          } else {
            this.$message.error(res.message)
          }
        }, () => {

        }) 
      },
      refreshMenu () {
        localStorage.localMenuData = ''
        this.$router.push({path: '/'})
        location.reload()
      },
      handleChange (vl) {
        //localMenuData addRData
        this.$editMenuPosition(this.tempData.subId, this.menuIndex, (res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
            this.fetchData()
            this.editMenuPosition = false
            
          } else {
            this.$message.error(res.message)
          }
        }, () => {

        }) 
      },
      initListData () {
        this.menuNameLangO = {
          en: 'List',
          zh_cn: '列表',
          ko: '목록',
          ru: 'список'
        }
      },
      deleteRecord (subId,menuName) {
        var that = this

        that.$confirm(this.$t('mao_global.tip.confirmDelete') + '【' + menuName + '】' + this.$t('mao_global.tip.notReset'), this.$t('mao_global.tip.text'), {
          confirmButtonText: this.$t('mao_global.btn.ok'),
          cancelButtonText: this.$t('mao_global.btn.cancel'),
          type: 'warning'
        }).then(() => {
          axios.post(`${baseurl}/menu/deleteMenu.do`,{subId: subId, token: that.token}).then(res=>{
            if (res.data && res.data.status && res.data.status === 200) {
              that.fetchData()
            }
          })
        }).catch(() => {

        }); // end $confirm

      },
      // 提交 新增/修改 表单
      submitEditForm () {
        var that = this



        that.editForm.menuName = that.menuNameLangO
        console.log(JSON.stringify(that.editForm))
        // return;

        var reqUri = `${baseurl}/menu/addMenu.do`
        var tipMsg = this.$t('app_addsc')

        if (that.modelTitle === this.$t('menuConfig.menu.editMenu')) {
          reqUri = `${baseurl}/menu/editMenu.do`;
          tipMsg = this.$t('menuConfig.menu.editSuccess')
        }

        this.$refs['editForm'].validate(function (result) {
          if(result){
            // 验证通过,调用module里的setUserInfo方法
            axios.post(reqUri,that.editForm).then(res=>{
              if (res.data && res.data.status && res.data.status === 200) {
                that.editMenuModelVisible = false
                that.$message(tipMsg)
                that.fetchData()

                that.editForm = {
                  subId: '',
                  menuId: '',
                  menuName: '',
                  superId: '0',
                  url: '',
                  uri: '',
                  menuSortNo: '100',
                  menuIcon: '',
                  meta: '',
                  token: localStorage.getItem("user") | null
                }
              }
            })
          }
        }.bind(that));
      },
      openEditSortModal () {
        var that = this

        // 打开摸态框
        that.editSortModalVisible = true
      },
      // 打开编辑摸态框
      openEditModel (type,parentId = null,data = null) {
        var that = this

        // 打开摸态框
        that.editMenuModelVisible = true



        if (that.menuNameLangA.length < 1) {
          axios.post(`${baseurl}/menu/getLanguage.do`).then(res=>{
            if (res.data && res.data.status && res.data.status === 200) {
              that.menuNameLangA = res.data.data
              that.menuNameLangA.forEach((it) => {
                that.menuNameLangO[it] = ""
              })
            }
          })
        }



        switch (type) {
          case 'ADD':
            that.modelTitle = this.$t('menuConfig.menu.addMenu2')
            // 初始化表单

            let sId = ''
            if (data && data.subId) {
              sId = data.subId
            }
            that.editForm = {menuName: '', superId: '0' || "",subId: sId, url: '', menuSortNo: '', meta: '', menuIcon: '', token: localStorage.getItem("user") | null}
            break;
          case 'SORT':
            break;
          default:
            that.modelTitle = this.$t('menuConfig.menu.editMenu')
            console.log(JSON.stringify(data, null, 2))
            that.editForm = {
              menuId: data.menuId,
              menuName: data.menuName,
              superId: '0',
              url: data.url,
              subId: data.subId || "",
              meta: '',
              menuSortNo: data.menuSortNo,
              menuIcon: data.menuIcon||"",
              token: localStorage.getItem("user") | null,
            }
            break;
        }
      },
      // 跳转
      jump (uri) {
        this.$router.push({path: uri})
      },
      // 获取初始化数据
      fetchData () {
        var that = this

        axios.post(`${baseurl}/menu/menuList.do`,{token: localStorage.getItem('user')}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.resultData = res.data.data
          }
        })
      },
      append(store, data) {
        store.append({ id: id++, label: 'testtest', children: [] }, data);
      },

      remove(store, data) {
        store.remove(data);
      },
      renderContent:function(createElement, { node, data, store }) {
        var self = this;
        return createElement('span', [
          createElement('span', node.label),
          createElement('span', {attrs:{
            style:"float: right; margin-right: 20px"
          }},[
            createElement('el-button',{attrs:{
              size:"mini"
            },on:{
              click:function() {
                // 添加按钮
                store.append({ id: self.baseId++, label: 'testtest', children: [] }, data);
                self.openEditModel('ADD',data.menuId, data)
              }
            }},self.$t('menuConfig.menu.addSubMenu')),
            createElement('el-button',{attrs:{
              size:"mini"
            },

              //  编辑
            //   on:{
            //   click:function() {
            //
            //     console.log(JSON.stringify(data, null, 2))
            //     self.openEditModel('EDIT',0,data)
            //   }
            // }},self.$t('mao_global.btn.edit')),
            // createElement('el-button',{attrs:{
            //   size:"mini",
            //   type:"danger"
            // },

              //SORT
              // todo 排序的
              on:{
                click:function() {
                  self.menuIndex = data.menuSortNo
                  self.tempData = data
                  self.editMenuPosition = true
                  // console.log(JSON.stringify(data, null, 2))
                  // self.openEditModel('SORT',0,data)
                  // todo 打开编辑排序模态框, 进行操作. 模态框只有一个排序表单就行了.
                }
              }},self.$t('mao_global.btn.sort')),

            createElement('el-button',{attrs:{
                size:"mini",
                type:""
              },
              on:{
              click:function() {
                // 编辑
                console.log(data)
                self.submitForm.name = data.name
                self.submitForm.icon = data.iconCls
                self.submitForm.url = data.path
                self.submitForm.menuId = data.menuId
                self.editMenuNameAndUrl = true
              }
            }},self.$t('app_edit')),
            
            createElement('el-button',{attrs:{
                size:"mini",
                type:"danger"
              },
              on:{
              click:function() {
                // 删除按钮
                self.deleteRecord(data.subId,data.name)
//                store.remove(data);
              }
            }},self.$t('mao_global.btn.delete')),
          ]),
        ]);
      }
    },
    mounted () { 
      var that = this
      that.fetchData()
    }
  }
</script>



// WEBPACK FOOTER //
// menu-list.vue?7d029fc4